import React from 'react';
import { notDefined } from 'src/utils/TypeCheckers';

export interface OriginalPath {
  setOriginalPath: (path: string) => void;
  getOriginalPath: () => string;
}

export function useOriginalPath(): OriginalPath {
  const [pathname, setPathname] = React.useState<string | undefined>(undefined);

  const setOriginalPath = (path: string) => {
    if (notDefined(pathname)) setPathname(path);
  };

  const getOriginalPath = () => pathname || '';

  return { setOriginalPath, getOriginalPath };
}
